import { getConfig } from "../_configs/AppConfig";

export function getApiBaseUrl(): string {
  if (process.env.NEXT_PUBLIC_WATSON_API_URL) {
    // Allow Watson URI to be passed via env variable for test environments
    return process.env.NEXT_PUBLIC_WATSON_API_URL;
  }
  const { publicRuntimeConfig } = getConfig();
  return publicRuntimeConfig.API_SPEC_URL.replace(/\/?schema-oas\.json$/, "");
}
